import { useMemo } from "react";
import type { Panel, PanelRow, Section } from "@electro-planner/domain";
import { buildPanelSld } from "../export/sld.ts";

/**
 * Live-enlinjeschema. Återanvänder `buildPanelSld` som PDF-exporten använder,
 * men renderar SVG-strängen inline så användaren kan se resultatet uppdateras
 * i realtid när raderna ändras. Vi wrappar SVG:n i en scroll-container så
 * stora centraler kan skrollas horisontellt/vertikalt utan att klippas.
 */
export function SldView({
  panel,
  sections,
  rows,
}: {
  panel: Panel | undefined;
  sections: ReadonlyArray<Section>;
  rows: ReadonlyArray<PanelRow>;
}) {
  const svg = useMemo(() => {
    if (rows.length === 0) return "";
    return buildPanelSld({ panel, sections, rows });
  }, [panel, sections, rows]);

  if (rows.length === 0) {
    return (
      <div className="flex flex-1 items-center justify-center bg-slate-50 text-sm text-slate-500">
        Lägg till rader i tabellen för att se enlinjeschemat.
      </div>
    );
  }

  return (
    <div className="flex h-full w-full flex-col overflow-hidden bg-slate-100">
      <div className="flex items-center justify-between border-b border-slate-200 bg-white px-4 py-2 text-xs text-slate-500">
        <span>
          Auto-genererat enlinjeschema — uppdateras när du ändrar raderna.
        </span>
        <span>Symbolsättning: egna ritningar i SS-EN 60617-stil.</span>
      </div>
      <div className="flex flex-1 justify-center overflow-auto p-6">
        <div
          className="h-fit w-full max-w-[220mm] rounded bg-white p-4 shadow-sm [&_svg]:h-auto [&_svg]:w-full"
          dangerouslySetInnerHTML={{ __html: svg }}
        />
      </div>
    </div>
  );
}
